import React from "react";
import "./styles.scss";

const NeedHelp = (props) => {
  const { question, content, call_us, chat, number, chatbot_link } = props;
  return (
    <div className="need-help-container">
      <h3>{question}</h3>
      <p>{content}</p>
      <span>{call_us}</span>
      <p>{number}</p>
      {/* <p>or</p>
      <a href={`${chatbot_link}`} target="_blanks" aria-label="chat with us">
        <p className="chat-with-us">{chat}</p>
      </a> */}
    </div>
  );
};

export default NeedHelp;
